// Formspree endpoint for the contact form. The destination inbox is set on
// the Formspree dashboard (not here), so no email address is ever exposed
// in the site's source code.
//
// To activate the contact form:
//   1. Create a free account at https://formspree.io using the inbox you
//      want messages delivered to.
//   2. Create a new form and copy its form ID (the part after /f/ in the
//      endpoint Formspree gives you).
//   3. Replace the placeholder below with that form ID.
export const FORMSPREE_FORM_ID = 'YOUR_FORMSPREE_FORM_ID';
export const FORMSPREE_ENDPOINT = `https://formspree.io/f/${FORMSPREE_FORM_ID}`;
